import React from 'react'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';

const renderSelectField = ({ input: { onChange, value }, props, label, defaultValue, meta: { touched, error, warning }, children, ...custom }) => {
    return <FormGroup>
        <Label for={label}>{label}</Label>
        <Input onChange={onChange} defaultValue={defaultValue}
            value={value} {...props} type="select" invalid={(touched && error) || (warning)}  {...custom}>
            {children}
        </Input>
        <FormFeedback>{error}</FormFeedback>
    </FormGroup>
}

export default renderSelectField